import { useEffect, useState } from 'react';
import { Paper, Loader, Center } from '@mantine/core';
import { marked } from 'marked';

interface MarkdownViewerProps {
  id: string;
  rawMd?: string;
  markdownFetchFn?:(id: string) => Promise<string>
}

const MarkdownViewer = ({ id, rawMd, markdownFetchFn }: MarkdownViewerProps) => {
  const [content, setContent] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMarkdown = async () => {
      setLoading(true);
      try {
        let markdownText;
        if (!!rawMd) {
          markdownText = rawMd;
        } else if (!!markdownFetchFn) {
          markdownText = await markdownFetchFn(id);
        } else {
          throw new Error('No markdown text nor markdownFetchFn provided');
        }

        // Convert markdown to HTML using marked
        const htmlContent = await marked(markdownText);
        setContent(htmlContent);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    fetchMarkdown();
  }, [id, rawMd]);

  if (loading) {
    return (
      <Paper p="md" withBorder>
        <Center>
          <Loader size="md" />
        </Center>
      </Paper>
    );
  }

  if (error) {
    return <Paper p="md" withBorder>Error: {error}</Paper>;
  }

  return (
    <Paper p="md" withBorder>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Paper>
  );
};

export default MarkdownViewer;
